import React from 'react';
import { Plus } from 'lucide-react';
import { Button } from '@relay-towing/ui';
import { useHasPermission } from '@/hooks/useDriverPermissions';

interface CreateCallBarProps {
  onClick: () => void;
  /** "Create Call" on the home tab, "Add Call" on the drivers map. */
  label: string;
}

/**
 * The bar pinned above the bottom navigation that starts a new call. Both
 * screens that show it drew the same markup; it lives here so the one
 * permission it needs is checked in one place. Without calls.create the
 * backend refuses the call the form would send, so the bar is not drawn.
 */
const CreateCallBar: React.FC<CreateCallBarProps> = ({ onClick, label }) => {
  const canCreateCalls = useHasPermission('calls.create');
  if (!canCreateCalls) return null;

  return (
    <div className="fixed bottom-[calc(5rem_+_env(safe-area-inset-bottom))] left-1/2 transform -translate-x-1/2 responsive-container bg-background border-t border-border z-30 p-4">
      <Button fullWidth size="lg" leadingIcon={<Plus />} onClick={onClick}>
        {label}
      </Button>
    </div>
  );
};

export default CreateCallBar;
